module.exports = __webpack_public_path__ + "img/6.3016da05.png";